import { render, staticRenderFns } from "./activity-icon.vue?vue&type=template&id=d0a70820"
import script from "./activity-icon.vue?vue&type=script&lang=js"
export * from "./activity-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports